import { useEffect, useState } from 'react';

/**
 * Monotonic tick for lightweight polling. The timer runs only while the
 * caller is mounted/enabled, and skips ticks while the browser tab is hidden
 * to avoid unnecessary external API traffic.
 */
export function usePollingTick(intervalMs: number, enabled = true): number {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    const interval = window.setInterval(() => {
      if (document.visibilityState === 'hidden') return;
      setTick(value => value + 1);
    }, intervalMs);
    return () => window.clearInterval(interval);
  }, [enabled, intervalMs]);

  return tick;
}
